import React, { useEffect } from 'react'
import { Field, ErrorMessage, useFormikContext } from 'formik'
import * as Yup from 'yup'
import TextField from '@mui/material/TextField'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import errorIcon from 'images/error-icon.svg'
// These are plain helpers (not components), so we use the non-React `t`.
import { t } from 'i18n'
import {
  zipValidation,
  nameValidation,
  customFieldValidation,
  phoneRegExp,
} from 'components/forms/validations'
import { stateOptions } from 'components/forms/SharedInputs'

const FormikOnChangeComponent = props => {
  const { setFormStatus } = props
  const formik = useFormikContext()
  /*
  const isAnyFieldInvalid = (vals) => {
    let validForm = true;
    for (let prop in vals) {
      if (vals[prop]) {
        let value = vals[prop]
        if (value === "" || value === undefined || value === null) {
          validForm = false;
          break; //haha
        }
      }
      
    }
    return validForm;
  } */
  //const isFormIncomplete = Object.values(formik.values).some(value => value === "" || value === false || value === undefined)

  useEffect(() => {
    //let formValueStatus = isAnyFieldInvalid(formik.values)
    // console.log("changing form state", formik)
    if (formik.dirty === false || Object.keys(formik.errors).length > 0) {
      setFormStatus('is-invalid')
    } else {
      setFormStatus('is-valid')
    }
  }, [formik])

  return <></>
}

const POSTPayloadContructor = (stepFormData, values) => {
  // Our API needs the collection of confirmations sent to it in a collection (not as fields)
  let confirmations = {}
  stepFormData.confirmations.forEach(confirmationField => {
    if (values.hasOwnProperty(confirmationField.id)) {
      confirmations[confirmationField.id] = values[confirmationField.id]
    } else {
      confirmations[confirmationField.id] = false
    }
  })

  // we need this field to be called "zipCode" for our API
  values['address2'] = values['address2'] || ''
  values['confirmations'] = confirmations
  return values
}

const renderTextInput = props => {
  const errorExists = props.error || props.errors

  return (
    <FormControl
      className={`field field-${props.field.name}${props.index || ''}`}
      key={props.field.name}
    >
      <TextField
        error={props.error && props.touched && true}
        // helperText={props.error && props.touched && props.error} // this appears below the field
        label={props.label}
        type={props.type}
        value={props.field.value}
        variant="filled"
        name={props.field.name}
        id={`${props.field.name}-helper`}
        onChange={e => {
          props.form.setFieldValue(props.field.name, e.target.value)
        }}
      />
      {errorExists && props.touched && (
        <div className="error">
          <ErrorMessage name={props.field.name} />
        </div>
      )}
      {errorExists && props.touched && (
        <img className="error-icon" src={errorIcon} alt="" />
      )}
    </FormControl>
  )
}
const zipInput = props => {
  const errorExists = props.error || props.errors
  const handleOnChange = e => {
    props.form.setFieldValue(props.field.name, e.target.value)
    props.lookupAddress({ ...props.values, zipCode: e.target.value })
  }

  return (
    <FormControl
      className={`field field-${props.field.name}${props.index || ''}`}
      key={props.field.name}
    >
      <TextField
        id={`${props.field.name}-helper`}
        error={props.error && props.form.isSubmitting && true}
        label={props.label}
        type={props.type}
        defaultValue={props.defaultValue}
        variant="filled"
        name={props.name}
        value={props.field.value}
        onChange={handleOnChange}
      />
      {errorExists && props.touched && (
        <div className="error">
          <ErrorMessage name={props.field.name} />
        </div>
      )}
      {errorExists && props.touched && (
        <img className="error-icon" src={errorIcon} alt="" />
      )}
    </FormControl>
  )
}
const renderSelectInput = props => {
  return (
    <FormControl
      variant="filled"
      className={`field field-${props.field.name}${props.index || ''}`}
      key={props.field.name}
    >
      <InputLabel htmlFor={`${props.field.name}-helper`}>
        {props.label}
      </InputLabel>
      <Select
        native
        label={props.label}
        value={props.field.value}
        variant="filled"
        onChange={e => {
          props.form.setFieldValue(props.field.name, e.target.value)
        }}
        inputProps={{
          name: props.name,
          id: `${props.field.name}-helper`,
        }}
      >
        <option
          aria-label={t('leadGen:select.emptyOption')}
          value=""
          key={-1}
        />
        {props.options.map((option, i) => {
          return (
            <option key={i} value={option.value}>
              {option.text}
            </option>
          )
        })}
      </Select>
      {props.error && props.touched && (
        <div className="error">
          <ErrorMessage name={props.field.name} />
        </div>
      )}
    </FormControl>
  )
}

// leadgen fields are a fixed set of field "types"
// `labelKey` is an i18n key resolved at render time via t()
const MAPPINGS = {
  firstName: {
    labelKey: 'leadGen:fields.firstName',
    type: 'text',
    placeholder: '',
    required: true,
  },
  lastName: {
    labelKey: 'leadGen:fields.lastName',
    type: 'text',
    placeholder: '',
    required: true,
  },
  fullName: {
    labelKey: 'leadGen:fields.fullName',
    type: 'text',
    placeholder: '',
  },
  email: {
    labelKey: 'leadGen:fields.email',
    type: 'email',
    placeholder: '',
    required: true,
  },

  address: {
    labelKey: 'leadGen:fields.address',
    type: 'text',
    placeholder: '',
    required: true,
  },
  address2: {
    labelKey: 'leadGen:fields.address2',
    type: 'text',
    placeholder: '',
  },
  city: {
    labelKey: 'leadGen:fields.city',
    type: 'text',
    placeholder: '',
  },
  state: {
    labelKey: 'leadGen:fields.state',
    type: 'state',
    placeholder: '',
    required: true,
  },
  zip: {
    labelKey: 'leadGen:fields.zip',
    type: 'zip',
    placeholder: '',
    required: true,
  },
  phoneNumber: {
    labelKey: 'leadGen:fields.phoneNumber',
    type: 'text',
    placeholder: '',
  },
  mobileNumber: {
    labelKey: 'leadGen:fields.mobileNumber',
    type: 'text',
    placeholder: '',
  },
  birthday: {
    labelKey: 'leadGen:fields.birthday',
    type: 'date',
  },
  birthdayMonth: {
    labelKey: 'leadGen:fields.birthdayMonth',
    type: 'birthdayMonth',
  },
  birthdayDay: {
    labelKey: 'leadGen:fields.birthdayDay',
    type: 'birthdayDay',
  },
  birthdayYear: {
    labelKey: 'leadGen:fields.birthdayYear',
    type: 'birthdayYear',
  },

  largeText: {
    labelKey: 'leadGen:fields.largeText',
    type: 'text-box',
  },

  customText1: {
    labelKey: 'leadGen:fields.customText1',
    type: 'text',
  },

  customText2: {
    labelKey: 'leadGen:fields.customText2',
    type: 'text',
  },

  customText3: {
    labelKey: 'leadGen:fields.customText3',
    type: 'text',
  },

  //Crazyass cat stuff
  newToBlue: {
    labelKey: 'leadGen:fields.newToBlue',
    type: 'select',
    required: true,
  },
  petGender: {
    labelKey: 'leadGen:fields.petGender',
    type: 'select',
    required: true,
  },
  petName: {
    labelKey: 'leadGen:fields.petName',
    type: 'text',
    placeholder: '',
    required: true,
  },
  petBirthDate: {
    labelKey: 'leadGen:fields.petBirthDate',
    type: 'date',
    required: true,
  },
  // 'legal-user-acknowledgement-confirmation': {
  //     label: "*By clicking Submit I acknowledge that I have read and agree to be bound by the Dailybreak CP, LLC."
  // }
}

// render a Formik component for our leadgen field types
const getFieldByType = ({ field, formik, index, lookupAddress }) => {
  let required = field.required || false
  let requiredString = required ? '*' : '' //add an asterisk, but only if req'd

  if (field.name === 'birthdayDay') {
    let options = []
    Array.from({ length: 31 }).forEach((_, i) => {
      options.push({ value: i + 1, text: i + 1 })
    })

    return (
      <Field
        key={index}
        name="birthdayDay"
        type="select"
        label={`${t(MAPPINGS[field.name].labelKey)}${requiredString}`}
        // placeholder={"Email"}
        component={renderSelectInput}
        options={options}
        // shrink={true}
        error={formik.errors.birthdayDay}
        touched={formik.touched.birthdayDay && true}
      />
    )
  }
  if (field.name === 'zip' || field.name === 'zipCode') {
    return (
      <Field
        values={formik.values}
        key={index}
        lookupAddress={lookupAddress}
        name="zipCode"
        label={`${t('leadGen:fields.zipCode')}${requiredString}`}
        error={formik.errors[field.name]}
        component={zipInput}
        variant="filled"
        touched={formik.touched[field.name] && true}
      />
    )
  }
  if (field.name === 'birthdayMonth') {
    let monthOptions = []
    monthOptions.push({ value: 1, text: t('leadGen:months.january') })
    monthOptions.push({ value: 2, text: t('leadGen:months.february') })
    monthOptions.push({ value: 3, text: t('leadGen:months.march') })
    monthOptions.push({ value: 4, text: t('leadGen:months.april') })
    monthOptions.push({ value: 5, text: t('leadGen:months.may') })
    monthOptions.push({ value: 6, text: t('leadGen:months.june') })
    monthOptions.push({ value: 7, text: t('leadGen:months.july') })
    monthOptions.push({ value: 8, text: t('leadGen:months.august') })
    monthOptions.push({ value: 9, text: t('leadGen:months.september') })
    monthOptions.push({ value: 10, text: t('leadGen:months.october') })
    monthOptions.push({ value: 11, text: t('leadGen:months.november') })
    monthOptions.push({ value: 12, text: t('leadGen:months.december') })

    return (
      <Field
        key={index}
        name="birthdayMonth"
        type="select"
        label={`${t(MAPPINGS[field.name].labelKey)}${requiredString}`}
        component={renderSelectInput}
        options={monthOptions}
        error={formik.errors.birthdayMonth}
        touched={formik.touched.birthdayMonth && true}
      />
    )
  }
  if (field.name === 'birthdayYear') {
    let yearOptions = []
    for (let i = new Date().getFullYear(); i >= 1900; i--) {
      yearOptions.push({ value: i, text: i })
    }

    return (
      <Field
        key={index}
        name="birthdayYear"
        type="select"
        label={`${t(MAPPINGS[field.name].labelKey)}${requiredString}`}
        component={renderSelectInput}
        options={yearOptions}
        error={formik.errors.birthdayYear}
        touched={formik.touched.birthdayYear && true}
      />
    )
  }

  if (MAPPINGS[field.name] && MAPPINGS[field.name].type === 'text') {
    let placeholder = field.displayTitle || MAPPINGS[field.name].placeholder
    let label = field.displayTitle || t(MAPPINGS[field.name].labelKey)
    return (
      <Field
        key={index}
        id={field.name}
        name={field.name}
        type="text"
        label={`${label}${requiredString}`}
        placeholder={placeholder}
        component={renderTextInput}
        error={formik.errors[field.name]}
        touched={formik.touched[field.name] && true}
      />
    )
  }
  if (field.name === 'state' || field.type === 'state') {
    let stateLabel = field.displayTitle || t(MAPPINGS[field.name].labelKey)
    return (
      <>
        <Field
          name={'state'}
          key={index}
          type="text"
          label={`${stateLabel}${requiredString}`}
          variant="filled"
          component={renderSelectInput}
          options={stateOptions}
          error={formik.errors[field.name]}
          touched={formik.touched[field.name] && true}
        />
      </>
    )
  }
  if (field.name === 'email') {
    return (
      <Field
        key={index}
        id={field.name}
        name={field.name}
        type="email"
        component={renderTextInput}
        label={`${t(MAPPINGS[field.name].labelKey)}${requiredString}`}
        placeholder={t('leadGen:fields.email')}
        value={formik.values.email}
        errors={formik.errors.email}
        touched={formik.touched.email && true}
      />
    )
  }

  return <p>{t('leadGen:unsupportedFieldType', { name: field.name })}</p>
}

const LeadGenField = ({ field, formik, index, lookupAddress }) => {
  return getFieldByType({ field, formik, index, lookupAddress })
}

const generateInitialValues = (userProfile, step, isEmbed) => {
  if (userProfile && step) {
    let initialValues = {}
    step.leadGenForm.fields &&
      step.leadGenForm.fields.forEach((field, i) => {
        initialValues[field.name] = ''
      })

    // try auto-filling some fields
    if (!isEmbed && initialValues.hasOwnProperty('firstName')) {
      initialValues['firstName'] = userProfile.guest
        ? ''
        : userProfile.firstName
    }

    if (!isEmbed && initialValues.hasOwnProperty('lastName')) {
      initialValues['lastName'] = userProfile.guest ? '' : userProfile.lastName
    }

    if (!isEmbed && initialValues.hasOwnProperty('email')) {
      initialValues['email'] = userProfile.guest ? '' : userProfile.username
    }
    step.leadGenForm.confirmations && step.leadGenForm.confirmations.forEach(field => {
      initialValues[field.id] = false
    })
    initialValues['leadId'] = step.leadGenForm.id
    return initialValues
  }
}

const formatSafariDate = str => {
  //this is quick and dirty, sorrynotsorry
  if (typeof str === 'string') {
    try {
      let arrDelimiter = str.indexOf('-') > -1 ? '-' : '/'
      let arr = str.split(arrDelimiter)
      let isoStr = `${arr[2]}-${arr[0]}-${arr[1]}`
      let parsedDate = new Date(isoStr)

      return parsedDate
    } catch (e) {
      console.warn(`problem parsing date`)
    }
  }
}
const safariParse2 = function (str) {
  try {
    let arrDelimiter = str.indexOf('-') > -1 ? '-' : '/'
    let arr = str.split(arrDelimiter)
    let isoStr = `${arr[2]}-${arr[0]}-${arr[1]}`
    return isoStr
  } catch (e) {
    console.warn(`problem parsing date`)
  }
}
function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [year, month, day].join('-')
}
const isADate = function (theVar) {
  let ret = false
  try {
    ret = typeof theVar.getMonth === 'function'
  } catch (e) {}
  return ret
}

const generateFormValidation2 = stepFormData => {
  // since we have the same set of fields for leadgen we can use this same config for all steps
  // we could probably generate this based on our MAPPINGS map above
  const validationSchema = {
    zip: Yup.string()
      .matches(/^[0-9]{5}(?:-[0-9]{4})?$/, t('leadGen:validation.zipLength'))
      .required(t('leadGen:validation.required')),
    firstName: nameValidation.firstName,
    lastName: nameValidation.lastName,
    email: Yup.string().email(t('leadGen:validation.invalidEmail')),
    birthdayDay: Yup.number().min(1).max(31),
    birthdayMonth: Yup.number().min(1).max(12),
    birthdayYear: Yup.number().moreThan(1900),
    customText1: customFieldValidation,
    customText2: customFieldValidation,
    customText3: customFieldValidation,
    zipCode: zipValidation,
    address: Yup.string(),
    address2: Yup.string(),
    city: Yup.string(),
    state: Yup.string(),
    phoneNumber: Yup.string().matches(
      phoneRegExp,
      t('leadGen:validation.invalidPhone'),
    ),
  }

  let yupSchema = {}
  stepFormData.fields &&
    stepFormData.fields.forEach(function (field) {
      if (validationSchema[field.name]) {
        if (field) {
          if (field.required && field.required === true) {
            yupSchema[field.name] = validationSchema[field.name].required(
              t('leadGen:validation.fieldRequired'),
            )
          } else {
            yupSchema[field.name] = validationSchema[field.name]
          }
        }
      }
    })
  let confirmationSchema = {}
  //Better way of doing checkbox validation. only some checkboxes are required. We need to slugify the field name or else named fields with spaces will freak js out.
  stepFormData.confirmations && stepFormData.confirmations.forEach(obj => {
    if (obj.required) {
      confirmationSchema[obj.id] = Yup.bool().oneOf(
        [true],
        t('leadGen:validation.required'),
      )
    }
  })
  let finalSchema = { ...confirmationSchema, ...yupSchema }
  return Yup.object(finalSchema)
}

export {
  renderTextInput,
  getFieldByType,
  LeadGenField,
  MAPPINGS,
  renderSelectInput,
  generateInitialValues,
  POSTPayloadContructor,
  FormikOnChangeComponent,
  generateFormValidation2,
}
